import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { skip, takeUntil } from 'rxjs/operators';
import * as reducers from '@app/reducers';
import { loadGrades } from '@app/history/history.actions';

@Component({
  selector: 'app-grade-selector',
  template: `
    <div ngbDropdown class="d-inline-block role-dropdown">
      <label for="role" class="label-text" *ngIf="isLabelVisible">Grade</label>
      <button
        class="btn btn-dropdown dark-text role-width"
        id="dropdownCategory"
        ngbDropdownToggle
      >
        {{ selectedGrade }}
        <i class="icon icon-down-arrow"></i>
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdownCategory"
        class="dropdownMenu"
      >
        <ng-container *ngFor="let grade of grades">
          <button
            ngbDropdownItem
            [disabled]="disabled"
            class="dropdown-item dropdown-value"
            (click)="onGradeChange(grade)"
            *ngIf="selectedGrade !== grade"
          >
            <div class="dropdown-text">
              {{ grade }}
            </div>
          </button>
        </ng-container>
      </div>
    </div>
  `,
  styles: [],
})
export class GradeSelectorComponent implements OnInit {
  @Output() gradeChange = new EventEmitter();
  @Input() isLabelVisible = false;
  @Input() disabled = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  allGrades = ['All grades'];
  grades = this.allGrades;
  @Input() selectedGrade = this.grades[0];

  constructor(private store: Store<reducers.State>) {}

  ngOnInit() {
    this.store.dispatch(
      loadGrades.init({ payload: { category: 'grade_level' } })
    );
    this.store
      .select(reducers.getGrades)
      .pipe(takeUntil(this.destroy$), skip(1))
      .subscribe((list: string[]) => {
        this.grades = this.allGrades.concat(list);
      });
  }

  onGradeChange(grade: string) {
    this.selectedGrade = grade;
    if (grade === this.allGrades[0]) {
      this.gradeChange.emit(null);
      return;
    }
    this.gradeChange.emit(grade);
  }
}
